import Voucher from '@/pages/library/voucher/routes'
import Segmentation from '@/pages/library/segmentation/routes'
import MemberPreferences from '@/pages/library/preferences/routes'
import RewardCategory from '@/pages/library/reward-category/routes'

export default {
  path: 'library',
  component: () => import('@/components/layouts/ChildLayout.vue'),
  children: [Voucher, ...Segmentation, ...MemberPreferences, RewardCategory]
}
